import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cmp-chatbot"
};
const _hoisted_2 = ["aria-label"];
const _hoisted_3 = {
  class: "cmp-chatbot__header"
};
const _hoisted_4 = {
  id: "chatbot-heading",
  class: "cmp-chatbot__title"
};
const _hoisted_5 = ["aria-label"];
const _hoisted_6 = {
  ref: "messageList",
  class: "cmp-chatbot__messages",
  role: "log",
  "aria-live": "polite"
};
const _hoisted_7 = {
  class: "sr-only"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0,
  class: "cmp-chatbot__bubble cmp-chatbot__bubble--assistant cmp-chatbot__bubble--pending",
  role: "status"
};
const _hoisted_11 = {
  class: "sr-only"
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "cmp-chatbot__loading-dots"
}, null, -1);
const _hoisted_13 = {
  id: "history-hint",
  class: "sr-only"
};
const _hoisted_14 = ["placeholder", "disabled", "aria-label"];
const _hoisted_15 = ["disabled"];
const _hoisted_16 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_chatbot_icon = _resolveComponent("chatbot-icon");
  return _openBlock(), _createBlock(_Teleport, {
    to: "body"
  }, [$options.showChatbot ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("button", {
    type: "button",
    class: "cmp-chatbot__launcher",
    ref: "launcher",
    "aria-label": $options.getLabel('chatbot.open.chatbot'),
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.open && $options.open(...args), ["prevent"]))
  }, [_createVNode(_component_chatbot_icon)], 8, _hoisted_2), $data.isOpen ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cmp-chatbot__backdrop",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.close && $options.close(...args))
  })) : _createCommentVNode("", true), $data.isOpen ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    ref: "panel",
    class: "cmp-chatbot__panel",
    role: "dialog",
    "aria-labelledby": "chatbot-heading",
    "aria-modal": "true",
    onKeydown: [_cache[8] || (_cache[8] = _withKeys((...args) => $options.close && $options.close(...args), ["esc"])), _cache[9] || (_cache[9] = (...args) => $options.trapFocus && $options.trapFocus(...args))]
  }, [_createElementVNode("button", {
    class: "sr-only sr-only-focusable cmp-chatbot__skip-link",
    type: "button",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.focusInput && $options.focusInput(...args))
  }, _toDisplayString($options.getLabel('chatbot.skip.to.input')), 1), _createElementVNode("header", _hoisted_3, [_createVNode(_component_chatbot_icon), _createElementVNode("h2", _hoisted_4, _toDisplayString($options.getLabel('chatbot.title')), 1), _createElementVNode("button", {
    ref: "closeBtn",
    class: "cmp-chatbot__close",
    type: "button",
    "aria-label": $options.getLabel('chatbot.close.chatbot'),
    onClick: _cache[3] || (_cache[3] = (...args) => $options.close && $options.close(...args))
  }, " × ", 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.messages, (msg, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: _normalizeClass(["cmp-chatbot__bubble", $options.bubbleClass(msg)])
    }, [_createElementVNode("span", _hoisted_7, _toDisplayString($options.getSpeakerLabel(msg.role)), 1), _createElementVNode("div", {
      innerHTML: $options.formatMessaage(msg.text)
    }, null, 8, _hoisted_8), msg.targetId ? (_openBlock(), _createElementBlock("button", {
      key: 0,
      onClick: $event => $options.jumpToContent(msg.targetId),
      class: "cmp-chatbot__jump-btn sr-only sr-only-focusable"
    }, _toDisplayString($options.getLabel('chatbot.go.to.content')), 9, _hoisted_9)) : _createCommentVNode("", true)], 2);
  }), 128)), $data.isSending ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("span", _hoisted_11, _toDisplayString($options.getLabel('chatbot.agent.typing')), 1), _hoisted_12])) : _createCommentVNode("", true)], 512), _createElementVNode("form", {
    class: "cmp-chatbot__form",
    onSubmit: _cache[7] || (_cache[7] = _withModifiers((...args) => $options.onSubmit && $options.onSubmit(...args), ["prevent"]))
  }, [_createElementVNode("span", _hoisted_13, _toDisplayString($options.getLabel('chatbot.arrow.keys.hint')), 1), _withDirectives(_createElementVNode("input", {
    ref: "chatInput",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.draft = $event),
    class: "cmp-chatbot__input",
    type: "text",
    placeholder: $options.getLabel('chatbot.input.placeholder'),
    disabled: $data.isSending,
    "aria-label": $options.getLabel('chatbot.input.aria.label'),
    onKeydown: [_cache[5] || (_cache[5] = _withKeys($event => $options.navigateHistory('up', $event), ["up"])), _cache[6] || (_cache[6] = _withKeys($event => $options.navigateHistory('down', $event), ["down"]))],
    name: "userMessage",
    autocomplete: "off"
  }, null, 40, _hoisted_14), [[_vModelText, $data.draft]]), _createElementVNode("button", {
    class: "cmp-chatbot__send",
    type: "submit",
    disabled: $data.isSending || !$data.draft.trim()
  }, _toDisplayString($options.getLabel('chatbot.submit.text')), 9, _hoisted_15)], 32), _createElementVNode("div", {
    class: "cmp-chatbot__legal-disclaimer",
    innerHTML: $options.getLabel('chatbot.legal.disclaimer')
  }, null, 8, _hoisted_16)], 544)) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]);
}